import React, { FC } from 'react';
import { Modal, Typography } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import features from '~/constants/features';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import LeftLayout from '~/layouts/LeftLayout';
import WizardContent from '~/layouts/WizardContent';
import { SuccessfulOnboardingImg } from '~/img';
import WizardContinueButton from '~/layouts/WizardContinueButton';
import { useProceedStep } from '~/controllers/wizard';
import { proceedManualOnboarding } from '~/api/onboarding';
import CompletionContainer from '~/pages/ksa/completion/components/CompletionContainer';

const AgentManualOnboarding: FC = () => {
  const { t } = useTranslation('ksaCompletion');

  const proceed = useProceedStep(proceedManualOnboarding);

  const onClick = () => {
    Modal.confirm({
      title: t('Submit Manual Onboarding'),
      content: (
        <Typography.Paragraph>
          <p>
            {t('Would you like to submit manual onboarding to complete the company application?')}
          </p>
        </Typography.Paragraph>
      ),
      okText: t('Proceed', { ns: 'common' }),
      cancelText: t('Cancel', { ns: 'common' }),
      icon: null,
      onOk() {
        proceed.mutateAsync().catch((e) => {
          console.error(`failed to submit; error:`, e);
        });
      },
    });
  };

  return (
    // <WizardContent
    //   left={
    //     <LeftLayout>
    //       <BottomLeftActions contactUsUrl={features.contactUsLinkHardDecline} />
    //     </LeftLayout>
    //   }
    //   content={
    <CompletionContainer>
      <Typography.Title>{t('Manual onboarding')}</Typography.Title>
      <Typography.Paragraph className="Completion-Paragraph">
        {t(
          'Please perform required the manual onboarding steps and confirm the merchant onboarding completion.'
        )}
      </Typography.Paragraph>
      <SuccessfulOnboardingImg className="Completion-Img" />
    </CompletionContainer>
    // }
    //   right={
    //     <WizardContinueButton
    //       id="manualOnboarding_confirmButton"
    //       onClick={onClick}
    //       loading={proceed.isLoading}
    //     >
    //       {t('Confirm completion')}
    //     </WizardContinueButton>
    //   }
    // />
  );
};

export default AgentManualOnboarding;
